window.loadingMask = null;
(function () {

    var isHomePage = function () {
        try {
            var homeUrl = sfEnv.homePageUrl;
            var url = homeUrl != '/' ? new URL(homeUrl).pathname : '/';
            return url.toLowerCase().replace('/', '') == location.pathname.toLowerCase().replace('/', '');
        } catch (e) {
            return false;
        }
    }

    //naming to be refactored in phase 2
    window.isInIframe = function () {

        if (isHomePage()) {
            return false;
        }

        var back = sessionStorage.getItem('showBack');

        if (back) {
            history.replaceState({ showBack: true }, '');
            //sessionStorage.removeItem('showBack');
        }

        if (history.state && history.state.showBack) {
            back = true;
        }

        return back;
    };

    document.documentElement.style.setProperty('--display-in-iframe', isInIframe() ? 'initial' : 'none');
    document.documentElement.style.setProperty('--hidden-in-iframe', isInIframe() ? 'none' : 'initial');

    var getPreviousNonScript = function (el) {
        var prev = el.previousElementSibling || el.parentElement;
        while (prev) {
            if (prev.tagName.toLowerCase() == 'script') {
                prev = prev.previousElementSibling || prev.parentElement;
            } else {
                return prev;
            }
        }
    };


    var isMaskNeeded = function () {
        var maskNeeded = false;

        document.querySelectorAll('script[data-sf-pers-id]').forEach(function (el) {
            if (maskNeeded) {
                return;
            }

            var prevNonScript = getPreviousNonScript(el);

            var rect = prevNonScript.getBoundingClientRect();

            if (rect.width && rect.height && rect.bottom < window.innerHeight) {
                maskNeeded = maskNeeded || true;
                console.log('mask needed, personalised widget in view:', rect, el);
            } else {
                console.log('mask not needed:', prevNonScript, rect);
            }
        });

        return maskNeeded;
    }

    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];

    loadingMask = new function () {

        var loadingMaskEl = document.getElementsByClassName('kmc-loading-mask')[0];

        var counter = 0;

        this.show = function () {
            if (!this.counter) {
                html.classList.add('uk-overflow-hidden');
                loadingMaskEl.classList.add('kmc-animation-pulse');
            }
            counter++;
        };

        this.dismiss = function (simpleDismiss) {

            if (!counter) {
                return;
            }

            counter--;

            if (!this.counter) {
                loadingMaskEl.classList.remove('kmc-animation-pulse');

                if (!simpleDismiss) {
                    loadingMaskEl.classList.add('kmc-animation-fade');
                }

                setTimeout(function () {
                    loadingMaskEl.classList.remove('kmc-animation-fade');
                    html.classList.remove('uk-overflow-hidden');
                }, 500);
            }
        }
    };

    var body = document.getElementsByTagName('body')[0];
    var header = document.getElementById('header');
    var isMobile = window.matchMedia('(max-width: 959px)');


    var onScroll = function (cb) {
        let lastLnownScrollPosition = 0;
        let ticking = false;
        window.addEventListener('scroll', function (e) {
            let direction = window.scrollY > lastLnownScrollPosition ? 'down' : 'up';
            lastLnownScrollPosition = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    cb(lastLnownScrollPosition, direction);
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
    };


    let headerTop = null;
    let lastPos = null;
    let lastDirection = null;
    let positionAtDirectionChange = 0;

    let backButton = document.querySelector('.kmc-iframe-back');

    backButton.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';


    onScroll(function (scrollPos, direction) {

        setTimeout(function () {
            backButton.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
        }, 0);


        if (lastDirection != direction) {
            positionAtDirectionChange = scrollPos;
        }

        if (lastDirection == direction) {

            if (positionAtDirectionChange > 150 && ((direction == 'up' && scrollPos > 5) || (direction == 'down' && scrollPos > 150))) {

                if (!header.classList.contains('header-top')) {
                    header.classList.add('header-top');
                    headerTop = headerTop || header.getBoundingClientRect().top;
                    document.documentElement.style.setProperty('--header-logo-height', isMobile.matches ? '30px' : '40px');
                    document.documentElement.style.setProperty('--header-padding-y', '15px');
                }

                let scrollDiff = scrollPos - lastPos;
                let newPos = header.getBoundingClientRect().top - scrollDiff;

                if (direction == 'up') {
                    newPos = Math.min(newPos, 0);
                } else if (direction == 'down') {
                    newPos = Math.max(headerTop, newPos);
                }

                header.style.top = newPos + 'px';

            } else {

                header.classList.remove('header-top');
                header.removeAttribute('style');

                document.documentElement.style.setProperty('--header-logo-height', isMobile.matches ? '50px' : '70px');
                document.documentElement.style.setProperty('--header-padding-y', '20px');
            }
        }

        lastPos = scrollPos;
        lastDirection = direction;
    });

    var menuOffcanvasToggle = document.getElementById('offcanvas-nav-primary-toggle');
    UIkit.icon(menuOffcanvasToggle, { icon: 'menu', ratio: 1.25 });

    document.getElementById('offcanvas-nav-primary').addEventListener('show', function (e) {
        UIkit.icon(menuOffcanvasToggle, { icon: 'close', ratio: 1.25 });
        setTimeout(function () {
            document.getElementById('header').classList.add('modal-shown');
        }, 300);
    });

    document.getElementById('offcanvas-nav-primary').addEventListener('hide', function (e) {
        UIkit.icon(menuOffcanvasToggle, { icon: 'menu', ratio: 1.25 });
        document.getElementById('header').classList.remove('modal-shown');
    });

    var fixExternLinks = function () {
        document.querySelectorAll('a[href]').forEach(function (a) {
            if (a.href.indexOf('javascript') == 0) return;

            try {
                var link = new URL(a.href);
                if (link.host != document.location.host) {
                    a.setAttribute('target', '_blank');
                    a.setAttribute('rel', 'noopener noreferrer');
                }
            } catch (e) { console.error(e) }
        });
    }


    function widgetNesting() {
        var parents = document.querySelectorAll('[id$=-nest-container]');

        parents.forEach(function (parent) {

            var childrenClass = parent.id.replace('-nest-container', '-nest-child');
            var children = document.querySelectorAll('.' + childrenClass);

            children.forEach(function (child) {
                console.log('nesting child widget:', childrenClass);
                parent.appendChild(child);
                //parent.classList.add('uk-padding', 'uk-padding-remove-horizontal');
            });

        });
    }

    widgetNesting();

    if (window.personalizationManager) {

        if (isMaskNeeded()) {
            loadingMask.show();
        }

        window.personalizationManager.addPersonalizedContentLoaded(function () {
            console.log('personalisation done');
            Initialization(function () {
                loadingMask.dismiss();
            });
        });
    } else {
        Initialization();
    }

    function initOldPagesWrapper() {
        var frameContainer = document.querySelector('[data-kmc-old-page]');
        if (frameContainer) {
            frameContainer.classList.add('uk-width-1-1');
            var frame = document.createElement('iframe');
            frame.src = frameContainer.dataset.kmcOldPage;
            frame.classList.add(['uk-height-1-1', 'uk-width-1-1']);
            frameContainer.appendChild(frame);
            addEventListener('message', function (e) {
                if (e.data && e.data.hasOwnProperty('form1')) {
                    frame.style.height = e.data.form1.height + 'px';
                }
            });
        }
    }

    function initIntermediaryPersonaSwitch () {
        document.querySelectorAll('[href*="/intermediaries"]').forEach(function (el) {
            el.addEventListener('click', function () {
                kmcPersonaBot.setCookie('intermediary');
            });
        });
    }

    function Initialization(cb) {

        var startTime = Date.now();
        console.log('Running layout init');

        fixExternLinks();

        document.querySelectorAll('.uk-grid').forEach(function (el) { el.setAttribute('uk-grid', ''); });
        document.querySelectorAll('.uk-slider').forEach(function (el) { el.setAttribute('uk-slider', ''); });

        widgetNesting();
        initOldPagesWrapper();

        document.title += " | Kensington Mortgages";

        document.querySelectorAll('a[href]').forEach(function (e) {
            e.addEventListener('click', function (e) {
                sessionStorage.setItem('showBack', "1");
            });
        });

        initIntermediaryPersonaSwitch();
        initSFInsight();

        function screenTest() {
            var matches = isMobile.matches;

            var footer = document.getElementsByTagName('footer')[0];
            var footerContainer = document.getElementsByClassName('footer-container')[0];

            if (matches) {
                if (footer.parentElement.tagName.toLowerCase() == 'body') {
                    footerContainer.appendChild(footer);
                }
            } else {
                body.appendChild(footer);
            }


            var waveSections = document.querySelectorAll('div.kmc-wave-padding');
            if (waveSections.length) {
                waveSections[waveSections.length - 1].classList.add('kmc-wave-last');
            }


            document.querySelectorAll('.hero-detach-cta .cta-container').forEach(function (ctaContainer) {
                if (matches) {
                    var el = ctaContainer.firstElementChild;
                    body.appendChild(el);
                    body.classList.add('has-detached-cta');
                    el.classList.add('hero-detached-cta');
                    el.classList.remove('uk-padding-remove-horizontal');
                } else {
                    var detachedEl = document.querySelectorAll('.hero-detached-cta')[0];
                    if (detachedEl) {
                        body.classList.remove('has-detached-cta');
                        detachedEl.classList.remove('hero-detached-cta');
                        detachedEl.classList.add('uk-padding-remove-horizontal');
                        ctaContainer.appendChild(detachedEl);
                    }
                }
            });

        }
        screenTest();
        isMobile.addListener(screenTest);

        var delay = 500 - (Date.now() - startTime);
        setTimeout(cb, delay);
    }


    //DEC tracking
    var trackData = function () {

        initMortgageGymUTMParams();

        document.addEventListener('click', function (e) {
            if (!e.target.matches("a,button,div[data-href]")) return;

            var el = e.target;
            var elID = el.getAttribute('id');
            var elText = el.innerText.trim() || el.getAttribute('aria-label') || el.tagName.to;
            var url = el.getAttribute('href') || el.getAttribute('data-href');

            var predicate = 'Click';
            var obj = elText || '';

            if (url) {
                obj += ' [' + url + '] ';
            }

            if (elID) {
                obj += ' #' + elID + ' ';
            }

            var sentence = {
                predicate: predicate,
                object: obj,
            };

            console.info('SF Insight sentence', sentence);

            window.DataIntelligenceSubmitScript._client.sentenceClient.writeSentence(sentence);
        });

        console.info('SF Insight initialised');
    }


    function initSFInsight () {
        if (window.decClientReady) {
            trackData();
        } else {
            document.addEventListener("decclientready", trackData);
        }
    }

})();

window.decClientReady = window.DataIntelligenceSubmitScript && window.DataIntelligenceSubmitScript._client && window.DataIntelligenceSubmitScript._client.sentenceClient;

window.initMortgageGymUTMParams = function () {

    var subjectID = window.DataIntelligenceSubmitScript._client.readCookie();
    var lpStorageKey = 'kmc_lp_search';

    if (!sessionStorage.getItem(lpStorageKey)) {
        sessionStorage.setItem(lpStorageKey, location.search);
    }

    document.querySelectorAll('a[href*="digi.mortgage"]').forEach(function (el) {

        var currentUrl = new URL(window.location.href);
        var targetUrl = new URL(el.getAttribute('href'));

        var personaKey = kmcPersonaBot.getPersonaKey();
        var personaUtmContentMap = {
            'ftb': 'first-time-buyer',
            'home-mover': 'home-mover',
            'remortgager': 'remortgage'
        }

        var utm_content = personaUtmContentMap[personaKey] || personaKey;
        var utm_term = currentUrl.pathname;

        targetUrl.searchParams.set('utm_medium', 'website_referral');
        targetUrl.searchParams.set('utm_term', utm_term);
        targetUrl.searchParams.set('utm_content', utm_content);

        if (subjectID) {
            targetUrl.searchParams.set('subject_id', subjectID);
        }

        ['utm_campaign', 'utm_source'].forEach(function (tag) {
            var searchParams = new URLSearchParams(sessionStorage.getItem(lpStorageKey));

            if (searchParams.has(tag)) {
                targetUrl.searchParams.set(tag, searchParams.get(tag));
            }
        });

        if (!targetUrl.searchParams.has('utm_source')) {
            targetUrl.searchParams.set('utm_source', 'direct');
            targetUrl.searchParams.set('utm_medium', 'website_referral');
        }

        el.setAttribute('href', targetUrl.href);
    });
}

window.kmcPersonaBot = new function () {
    var flow = [
        {
            "q": "Which of these best describes you?",
            "a": {
                'prospective-customer': {
                    'key': 'prospective-customer',
                    'title': 'Looking for a Mortgage',
                    'q': 'What is your mortgage situation?',
                    'thankYouMessage': (segment) => `We can now help you find the information you’ll need to know as a <strong>prospective customer</strong> who is <strong>${segment}</strong>`,
                    'a': {
                        'ftb': {
                            'key': 'ftb',
                            'title': 'a first time buyer',
                            'link': '/prospective-customer-pages/ftb/for-first-time-buyers'
                        },
                        'home-mover': {
                            'key': 'home-mover',
                            'title': 'a home mover',
                            'link': '/prospective-customer-pages/home-mover/for-home-movers'
                        },
                        'remortgager': {
                            'key': 'remortgager',
                            'title': 'a remortgager',
                            'link': '/prospective-customer-pages/remo/for-remortgaging'
                        },
                        'buy-to-let': {
                            'key': 'buy-to-let',
                            'title': 'buying to let',
                            'link': '/prospective-customer-pages/buy-to-let-investor/for-buy-to-let-investors'
                        },
                    },
                },
                'existing-customer': {
                    'key': 'existing-customer',
                    'title': 'Existing Customer',
                    'link': '/existing/for-existing-customers',
                    'thankYouMessage': () => `We can now help you find the information you’ll need to know as an <strong>existing customer.</strong>`
                },
                'home': {
                    'key': 'home',
                    'title': 'More about Kensington',
                    'link': '/for-everything-else/about-kensington/',
                    'thankYouMessage': () => null,
                },
                // 'browser': {
                //     'key': 'browser',
                //     'title': 'Just browsing',
                //     'link': '/new/browse/start/',
                //     'thankYouMessage': () => null,
                // }
            }
        }
    ];

    var topLevelAnswers = flow[0]['a'];

    var container = null;
    var header;
    var ctaContainer;
    var messagesContainer;
    var closeButton;

    this.setCookie = function (personaKey, maxAge = 2629746) {
        document.cookie = `kmc_persona=${personaKey};path=/;max-age=${maxAge};samesite=strict;`
    }

    this.resetPersona = function () {
        kmcPersonaBot.setCookie('', -1);
    }

    this.setFlow = function (f) {
        flow = f;
    }

    this.show = function (resetPersona = false, answer = null) {
        var botContainer = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(botContainer);
        UIkit.modal(botContainer).show();
        init(botContainer, answer);

        if (resetPersona) {
            kmcPersonaBot.resetPersona();
        }
    }

    var init = function (container_, answer = null) {
        container_.innerHTML = '';
        container = document.createElement('div');
        container_.style.setProperty('z-index', '9999');
        container_.appendChild(container);
        container_.classList.add('uk-padding-remove', 'uk-padding-top', 'uk-margin-auto');

        container.classList.add('kmc-pb', 'kmc-bg-color-white', 'uk-overflow-hidden', 'uk-position-relative', 'uk-flex', 'uk-flex-column');

        header = document.createElement('div');
        header.classList.add('kmc-pb-header', 'uk-padding', 'uk-flex', 'uk-flex-middle');

        var title = document.createElement('h3');
        title.classList.add('uk-flex-1', 'uk-text-center@m', 'uk-margin-remove')
        title.innerText = 'TELL US ABOUT YOU';
        header.appendChild(title);

        closeButton = document.createElement('a');
        closeButton.classList.add('uk-icon', 'uk-icon-link', 'uk-modal-close');
        closeButton.setAttribute('uk-icon', 'icon: close; ratio: 1')
        closeButton.onclick = function (e) {
            e.preventDefault();
            container.remove();
        };
        header.appendChild(closeButton);

        container.appendChild(header);
        messagesContainer = document.createElement('div');
        messagesContainer.classList.add('kmc-pb-messages', 'uk-flex-1', 'uk-flex', 'uk-flex-column', 'uk-padding', 'uk-overflow-auto');
        container.appendChild(messagesContainer);

        ctaContainer = document.createElement('div');
        ctaContainer.setAttribute('uk-grid', '');
        ctaContainer.classList.add('uk-grid', 'uk-grid-small', 'kmc-pb-ctas', 'uk-padding', 'uk-child-width-1-1');
        container.appendChild(ctaContainer);

        if(answer) {
            renderQuestion(topLevelAnswers[answer])
        } else {
            flow.forEach(function (q) {
                renderQuestion(q);
            });
        }


    }

    var renderCTAs = function (CTAs) {
        ctaContainer.innerHTML = '';

        if (!CTAs) {
            return;
        }

        setTimeout(function () {
            var i = 0;

            CTAs.forEach(function (cta) {
                var el = document.createElement('a');
                el.href = cta.link;
                el.innerText = cta.title;
                el.setAttribute('data-key', cta.key);
                el.classList.add('uk-display-block', 'uk-margin-small', 'uk-button', 'uk-button-primary', 'uk-button-large', 'uk-border-pill', 'uk-text-bold');

                el.classList.add('uk-animation-slide-top');
                i++;

                el.onclick = function (e) {
                    e.preventDefault();
                    cta.onClick(cta);
                }
                var wrap = document.createElement('div');
                wrap.appendChild(el);
                ctaContainer.appendChild(wrap);
            });
        }, 1000);
    }

    var renderThankYou = function (a, thankYouMessage) {

        //kmcPersonaBot.setCookie(a.key);

        if (!thankYouMessage) {
            document.location.href = a.link;
            return;
        }

        messagesContainer.innerHTML = '';
        messagesContainer.classList.add('uk-text-center', 'uk-flex-middle', 'uk-flex-center', 'uk-animation-fade');
        messagesContainer.innerHTML = `
                                                    <h1>Thanks!</h1>
                                                    <p class="uk-text-lead">
                                                        ${thankYouMessage}
                                                    </p>
                                                    <a href="${a.link}" class="uk-display-block uk-margin uk-margin-top-medium uk-button uk-button-primary uk-button-large uk-border-pill uk-text-bold">EXPLORE MY OPTIONS</a>
                                                `;

        setTimeout(function (){
            location.href = a.link;
        },1000);

    }


    var renderQuestion = function (q) {

        if(!q.hasOwnProperty('q') && !q.hasOwnProperty('a')){
            var thankYouMessage = q.hasOwnProperty('thankYouMessage') ? q.thankYouMessage() : q.thankYouMessage(q.title);
            renderThankYou(q, thankYouMessage);
        }

        if(q.hasOwnProperty('q')){
            messagesContainer.appendChild(getMessageMarkup(q.q, 'kmc-pb-q'));
        }

        if (!q.hasOwnProperty('a')) return;

        var CTAs = [];
        Object.keys(q.a).forEach((k) => {
            var cta = q.a[k];
            cta.onClick = function (a) {
                renderCTAs(null);
                messagesContainer.appendChild(getMessageMarkup(a.title, 'kmc-pb-a', 0));

                setTimeout(function () {
                    if (a.hasOwnProperty('q')) {
                        renderQuestion(a);
                    } else {
                        var thankYouMessage = a.hasOwnProperty('thankYouMessage') ? a.thankYouMessage() : q.thankYouMessage(a.title);
                        renderThankYou(a, thankYouMessage);
                    }
                }, 1000);
            }
            CTAs.push(cta);
        });

        renderCTAs(CTAs);
    }

    var getMessageMarkup = function (message, clasName, delay = 1500) {
        var el = document.createElement('div');
        el.classList.add(clasName);
        el.classList.add('uk-padding-small', 'uk-margin-small', 'uk-animation-slide-bottom-medium');
        el.innerText = '';

        setTimeout(function () {
            el.innerText = message;
        }, 0);

        return el;
    }

    this.getPersonaKey = function () {
        var cookie = document.cookie.split(';').filter(c => c.indexOf('kmc_persona') > -1);
        if (!cookie.length) {
            return null;
        }
        return cookie[0].trim().split('=')[1];
    }
};
